import { render, staticRenderFns } from "./DeleteIpAddress.vue?vue&type=template&id=7152b382"
import script from "./DeleteIpAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteIpAddress.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports